// import { useQuery, useMutation } from "vue-query";
// import glasson from '@/services/glasson'
import { reactive, toRefs } from 'vue'
import API_CONFIG from '@/configs/api.config'

export const DEFINITION_API_PATH = `${API_CONFIG.GLASSON}/helloo-definition`
export const UPLOAD_API_PATH = `${API_CONFIG.GLASSON}/upload-helloo-thumbnail`

export const useQuery = () => {
  const state = reactive({
    isLoading: false,
    isSuccess: false,
    data: {} as AnyObject,
    fileData: {} as AnyObject,
    isError: false,
  })

  const fetchList = async () => {
    try {
      state.isError = false
      state.isSuccess = false
      state.isLoading = true
      const res = await fetch(DEFINITION_API_PATH)
      state.data = await res.json()
      state.isSuccess = true
    }
    catch (error) {
      state.isError = true
    }
    state.isLoading = false
  }

  const uploadFile = async (formData) => {
    try {
      state.isError = false
      state.isSuccess = false
      state.isLoading = true
      const res = await fetch(UPLOAD_API_PATH, {
        method: 'POST',
        body: formData,
      })
      state.fileData = await res.json()
      state.isSuccess = true
    }
    catch (error) {
      state.isError = true
    }
    state.isLoading = false
  }

  return {
    ...toRefs(state),
    fetchList,
    uploadFile,
  }
}
